// Store Pinia para gerenciar o estado da busca global (REA, Comunidade, Usuário, Trilha) e filtros relacionados.

import { defineStore } from 'pinia'

export const useSearchStore = defineStore('search', {
  state: () => {
    return {
      // Inputs de busca para cada tipo de entidade
      searchInput: '', // Busca geral
      searchInputREA: '', // Busca para REAs
      searchInputComunidade: '', // Busca para Comunidades
      searchInputUsuario: '', // Busca para Usuários
      searchInputTrilha: '', // Busca para Trilhas

      // Resultados e controle de busca
      totalElementsSearch: 0, // Total de resultados da busca geral
      noResultsSearch: false, // Flag para indicar se não há resultados na busca geral
      tipoBusca: 'rea', // Tipo de busca ativa ('rea', 'comunidade', 'user', 'trilha')
      cardsSearch: [], // Resultados gerais
      cardsREA: [], // Resultados de REAs
      cardsComunidade: [], // Resultados de Comunidades
      cardsUsuario: [], // Resultados de Usuários
      cardsTrilha: [], // Resultados de Trilhas
      urlREA: '', // URL da busca de REAs
      urlComunidade: '', // URL da busca de Comunidades
      urlUsuario: '', // URL da busca de Usuários
      urlTrilha: '', // URL da busca de Trilhas
      totalElementsREA: 0, // Total de REAs encontrados
      totalElementsComunidade: 0, // Total de Comunidades encontradas
      totalElementsUsuario: 0, // Total de Usuários encontrados
      totalElementsTrilha: 0, // Total de Trilhas encontradas
      noresultsREA: false, // Flag para indicar se não há resultados de REA
      noresultsComunidade: false, // Flag para indicar se não há resultados de Comunidade
      noresultsUsuario: false, // Flag para indicar se não há resultados de Usuário
      noresultsTrilha: false, // Flag para indicar se não há resultados de Trilha
      newSearch: 0, // Flag para indicar nova busca
      headerUpdateFlag: 0, // Flag para forçar atualização do header

      // Paginação para cada tipo de entidade
      currentPageREA: 1,
      currentPageComunidades: 1,
      currentPageUsuarios: 1,
      currentPageTrilha: 1,

      // Filtros avançados para busca
      selectedLicencas: [], // Filtros de licenças para REA
      selectedAreas: [], // Filtros de áreas para REA
      selectedFuncoes: [], // Filtros de funções para Usuário
      selectedInteresses: [], // Filtros de interesses para Usuário

      shouldFetchNext: false,

      // Flags para indicar se já foi realizada uma busca em cada aba
      searchedREA: false,
      searchedComunidade: false,
      searchedUsuario: false,
      searchedTrilha: false,

      // Flag para indicar se um REA foi deletado a partir da página de detalhes
      deletedReaFromDetail: false,
    };
  },

  actions: {
    // Reseta todos os dados do estado da busca para o padrão inicial
    reset() {
      this.searchInput = '';
      this.searchInputREA = '';
      this.searchInputComunidade = '';
      this.searchInputUsuario = '';
      // this.searchInputTrilha = '';
      this.cardsSearch = [];
      this.cardsREA = [];
      this.cardsComunidade = [];
      this.cardsUsuario = [];
      // this.cardsTrilha = [];
      this.totalElementsSearch = 0;
      this.totalElementsREA = 0;
      this.totalElementsComunidade = 0;
      this.totalElementsUsuario = 0;
      // this.totalElementsTrilha = 0;
      this.noResultsSearch = false;
      this.noresultsREA = false;
      this.noresultsComunidade = false;
      this.noresultsUsuario = false;
      // this.noresultsTrilha = false;
      this.newSearch = 0;
      this.headerUpdateFlag = 0;
      this.tipoBusca = 'rea';
      this.currentPageREA = 1;
      this.currentPageComunidades = 1;
      this.currentPageUsuarios = 1;
      // this.currentPageTrilha = 1;
      this.selectedLicencas = [];
      this.selectedAreas = [];
      this.selectedFuncoes = [];
      this.selectedInteresses = [];
      this.urlREA = '';
      this.urlComunidade = '';
      this.urlUsuario = '';
      // this.urlTrilha = '';

      // reset das flags de busca
      this.searchedREA = false;
      this.searchedComunidade = false;
      this.searchedUsuario = false;
      // this.searchedTrilha = false;
    },

    resetTrilha() {
      this.searchInputTrilha = '';
      this.cardsTrilha = [];
      this.totalElementsTrilha = 0;
      this.noresultsTrilha = false;
      this.searchedTrilha = false;
      this.currentPageTrilha = 1;
      this.urlTrilha = '';
    },

    // Incrementa flag para sinalizar atualização do header
    triggerHeaderUpdate() {
      this.headerUpdateFlag++;
    },

    // Define página atual conforme tipo de busca
    setCurrentPage(page) {
      if (this.tipoBusca === 'rea') {
        this.currentPageREA = page;
      } else if (this.tipoBusca === 'comunidade') {
        this.currentPageComunidades = page;
      } else if (this.tipoBusca === 'user') {
        this.currentPageUsuarios = page;
      } else if (this.tipoBusca === 'trilha') {
        this.currentPageTrilha = page;
      }
    },

    // Retorna página atual conforme tipo de busca
    getCurrentPage() {
      if (this.tipoBusca === 'rea') {
        return this.currentPageREA;
      } else if (this.tipoBusca === 'comunidade') {
        return this.currentPageComunidades;
      } else if (this.tipoBusca === 'user') {
        return this.currentPageUsuarios;
      } else if (this.tipoBusca === 'trilha') {
        return this.currentPageTrilha;
      }
    },

    // Reseta página da aba ativa ao trocar de aba
    resetCurrentTabPage() {
      if (this.tipoBusca === 'rea') {
        this.currentPageREA = 1;
      } else if (this.tipoBusca === 'comunidade') {
        this.currentPageComunidades = 1;
      } else if (this.tipoBusca === 'user') {
        this.currentPageUsuarios = 1;
      } else if (this.tipoBusca === 'trilha') {
        this.currentPageTrilha = 1;
      }
    },

    // Retorna o searchInput conforme tipo de busca ativa
    getCurrentSearchInput() {
      if (this.tipoBusca === 'rea') {
        return this.searchInputREA;
      } else if (this.tipoBusca === 'comunidade') {
        return this.searchInputComunidade;
      } else if (this.tipoBusca === 'user') {
        return this.searchInputUsuario;
      } else if (this.tipoBusca === 'trilha') {
        return this.searchInputTrilha;
      }
      return '';
    },

    // Define o searchInput conforme tipo de busca ativa
    setCurrentSearchInput(val) {
      if (this.tipoBusca === 'rea') {
        this.searchInputREA = val;
      } else if (this.tipoBusca === 'comunidade') {
        this.searchInputComunidade = val;
      } else if (this.tipoBusca === 'user') {
        this.searchInputUsuario = val;
      } else if (this.tipoBusca === 'trilha') {
        this.searchInputTrilha = val;
      }
    },

    markDeletedFromDetail() {
      this.deletedReaFromDetail = true;
    },
    
    clearDeletedFromDetail() {
      this.deletedReaFromDetail = false;
    },
  }
})